<tt-page *ngIf="!!edit">
    <tt-card class="col-xs-12 col-md-4 sp-0">
        <tt-input [hidden]="edit.cust_no === '0'" ttLabel="cust_no" [ttModel]="edit.cust_no" ttReadonly [ttButtons]="custNoButtons"></tt-input>
        <tt-input [hidden]="edit.cust_no !== '0'" ttLabel="cust_no" [ttModel]="edit.cust_no" ttReadonly></tt-input>
        <tt-search ttLabel="customer_name" [(ttModel)]="edit.customer_name" [ttSearch]="searchCustomerNames" (ttOnSelected)="onCustomerNameSelected($event)" (ttOnClear)="onCustomerNameSelected()"></tt-search>
        <tt-checkbox ttLabel="isactive" [(ttModel)]="edit.isactive"></tt-checkbox>
        <tt-button-save ttText="save" (ttClick)="saveChanges()" [ttLoading]="saving"></tt-button-save>
    </tt-card>
</tt-page>
